<template>
  <div class="workspace">
    <!-- 顶部 tab 栏 -->
    <div class="tab">
      <div class="item" @click="goList(1)">
        <img src="../../assets/image/待处理.png" alt=""/>
        <div>待处理</div>
      </div>
      <div class="item" @click="goList(2)">
        <img src="../../assets/image/已处理.png" alt=""/>
        <div>已处理</div>
      </div>
      <div class="item" @click="goList(3)">
        <img src="../../assets/image/已发起.png" alt=""/>
        <div>已发起</div>
      </div>
      <div class="item" @click="goList(4)">
        <img src="../../assets/image/我收到的.png" alt=""/>
        <div>我收到的</div>
      </div>
    </div>

    <!-- 分类栏 -->

    <!-- <el-tabs @tab-click="handleClick" v-model="activeName"> -->
    <el-collapse v-model="actives" v-loading="loading">
      <van-tabs v-model="activeTab" @change="getActiveTab">
        <!-- <van-tab name="全部" title="全部"></van-tab> -->
        <van-tab
            v-for="(group, index) in formList.list"
            :key="index"
            :name="index"
            :title="group.name"
        ></van-tab>
      </van-tabs>
      <div>
        <div ref="tabsContent" style="overflow-y: auto; height: 79vh;">
          <el-collapse-item
              :id="'tab-' + index"
              v-for="(group, index) in formList.list"
              :key="index"
              :name="group.name"
          >
            <template slot="title">
              <!-- <img :src="group.icon" alt="" class="icon" /> -->
              {{ group.name }}
            </template>
            <div style="display: flex; flex-wrap: wrap;">
              <div
                  v-for="(item, index) in group.tptList"
                  :key="index"
                  class="form-item"
                  @click="enterItem(item)"
              >
                <div
                    style=" display: flex; flex-direction: column; align-items: center;"
                >
                  <i
                      :class="item.Icon.icon"
                      :style="'background: ' + item.Icon.background"
                  ></i>
                  <div class="tptName">
                    {{ item.name }}
                    <!-- <ellipsis hover-tip :content="item.name" /> -->
                    <!-- <span>发起审批</span> -->
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </div>
      </div>
    </el-collapse>
    <div style="display: flex; align-items: center">
      <div
          v-for="(item, index) in formList.searchResult"
          :key="index"
          class="form-item"
          @click="enterItem(item)"
      >
        <i :class="item.icon" :style="'background: ' + item.background"></i>
        <div>
          <span>{{ item.formName }}</span>
          <span>发起审批</span>
        </div>
      </div>
      <!-- <div
            class="no-data"
            v-show="formList.searchResult.length === 0 && formList.name !== ''"
          >
            没有找到相关的表单 😥
          </div> -->
    </div>
    <div class="no-data" v-show="formList.list.length == 0">暂无数据 😀</div>

    <!-- 发起审批 弹框 -->
    <el-drawer
        title="发起审批"
        size="40%"
        :visible.sync="openItemDl"
        append-to-body
        class="editdrawer spDrawer"
        @close="Close"
    >
      <!-- style="top: 20px" -->
      <!-- <initiate-process
        ref="processForm"
        :code="selectForm.tptId"
        v-if="openItemDl"
      ></initiate-process> -->

      <el-timeline style="margin: 50px 0px 0px">
        <el-timeline-item v-for="(i, index) in InitFlowNodeList" :key="index">
          <!-- :timestamp="i.addTime" -->
          {{ i.nodeName }} <span v-if="i.makers">- {{ i.makers }}</span>
          <!-- 单选 -->
          <el-dropdown
              style="float: right"
              trigger="click"
              @command="handleCommand"
              v-if="i.selectMode == 1"
          >
            <span class="el-dropdown-link">
              <el-button
                  @click="handelApproval"
                  v-if="i.nodeType == 'APPROVAL' && i.selfSelect == 1"
                  size="mini"
                  icon="el-icon-plus"
              ></el-button>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                  v-for="j in i.AltUserList"
                  :key="j.id"
                  :command="j.id"
              >{{ j.name }}
              </el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>

          <!-- 多选 -->
          <el-select
              style="width: 92%"
              size="mini"
              v-if="
              i.selectMode == 2 && i.nodeType == 'APPROVAL' && i.selfSelect == 1
            "
              v-model="ids"
              multiple
              placeholder="请选择审批人"
              @change="handleCommand1"
          >
            <el-option
                v-for="j in i.AltUserList"
                :key="j.id"
                :label="j.name"
                :value="j.id"
            />
          </el-select>
        </el-timeline-item>
      </el-timeline>
      <div
          class="demo-drawer__footer"
          style="text-align: center; margin: 30px 0 0px"
      >
        <el-button @click="Close">取 消</el-button>
        <el-button type="primary" @click="submitForm">提 交</el-button>
      </div>
    </el-drawer>

    <!-- 审批 弹窗 -->
    <!-- style="top: 20px" -->
    <el-drawer
        title="审批详情"
        :visible.sync="drawer"
        destroy-on-close
        class="shenpi"
        size="35%"
        append-to-body
        @close="cancel"
    >
      <el-descriptions class="title" :column="2">
        <el-descriptions-item label="流程名称">
          {{ shenPiList.customName }}
        </el-descriptions-item>
        <el-descriptions-item label="模板名称">
          {{ shenPiList.tptName }}
        </el-descriptions-item>
        <el-descriptions-item label="模板分组">
          {{ shenPiList.tptGroupName }}
        </el-descriptions-item>

        <el-descriptions-item label="发起人">
          {{ shenPiList.applyMan }}
        </el-descriptions-item>
        <el-descriptions-item label="发起时间">
          {{ shenPiList.applyTime }}
        </el-descriptions-item>
        <!-- <el-descriptions-item label="当前节点">
          <el-tag size="small">{{ shenPiList.activiteName }}</el-tag>
        </el-descriptions-item> -->
        <!-- <el-descriptions-item label="节点类型">
          {{ shenPiList.ActiviteTypeDesc }}
        </el-descriptions-item> -->
      </el-descriptions>
      <!-- 制证申请 -->
      <div class="form" v-if="shenPiList.TptGroupId == 'TG_MakeCard'">
        <el-form ref="form" :model="MakeCardList" label-width="120px">
          <el-form-item label="护照号" prop="Passport">
            <el-input
                v-model="MakeCardList.Passport"
                placeholder="请输入护照号"
                :readonly="true"
            />
          </el-form-item>
          <el-form-item label="药物过敏史" prop="Allergy">
            <el-input
                v-model="MakeCardList.Allergy"
                placeholder="请输入药物过敏史"
                :readonly="true"
            />
          </el-form-item>
          <el-form-item label="紧急联系人" prop="TouchMan">
            <el-input
                v-model="MakeCardList.TouchMan"
                placeholder="请输入紧急联系人"
                :readonly="true"
            />
          </el-form-item>
          <el-form-item label="紧急联系电话" prop="TouchTel">
            <el-input
                v-model="MakeCardList.TouchTel"
                placeholder="请输入紧急联系电话"
                :readonly="true"
            />
          </el-form-item>
          <el-form-item label="收件人" prop="Recipient">
            <el-input
                v-model="MakeCardList.Recipient"
                placeholder="请输入收件人"
                :readonly="true"
            />
          </el-form-item>
          <el-form-item label="收件人联系电话" prop="RecMobile">
            <el-input
                v-model="MakeCardList.RecMobile"
                placeholder="请输入收件人联系电话"
                :readonly="true"
            />
          </el-form-item>
          <el-form-item label="收件地址" prop="RecAddr">
            <el-input
                v-model="MakeCardList.RecAddr"
                placeholder="请输入收件地址"
                :readonly="true"
            />
          </el-form-item>
        </el-form>
      </div>
      <!-- 转正申请 -->
      <div class="form" v-if="shenPiList.TptGroupId == 'TG_TMUpgrade'">
        <el-form ref="form" :model="ApplyList" label-width="120px">
          <el-form-item label="姓名" prop="Name">
            <el-input
                v-model="ApplyList.Name"
                placeholder="请输入姓名"
                :readonly="true"
            />
          </el-form-item>
          <el-form-item label="蓝天编号" prop="Code">
            <el-input
                v-model="ApplyList.Code"
                placeholder="请输入蓝天编号"
                :readonly="true"
            />
          </el-form-item>
          <el-form-item label="身份证号" prop="IdCard">
            <el-input
                v-model="ApplyList.IdCard"
                placeholder="请输入身份证号"
                :readonly="true"
            />
          </el-form-item>
          <el-form-item label="附件" prop="Annex">
            <file-upload
                v-model="ApplyList.Annex"
                :isShowTip="false"
                :isShowDel="false"
            />
          </el-form-item>
        </el-form>
      </div>
      <!-- 自定义申请 -->
      <div class="form" v-if="Show">
        <initiate-process1
            ref="processForm"
            :code="shenPiList.tptId"
            :forms="formData"
            :formPerms="shenPiList.formPerms"
        ></initiate-process1>
      </div>

      <div class="form">
        <el-timeline style="margin: 20px 0">
          <el-timeline-item
              v-for="(i, index) in processList"
              :key="index"
              :timestamp="i.addTime"
          >
            {{ i.content }}
          </el-timeline-item>
        </el-timeline>
      </div>
      <div class="form" v-if="buttonShow">
        <div style="margin-top: 10px">审批</div>
        <el-form
            ref="dataForm"
            :model="dataForm"
            label-width="120px"
            :rules="dataFormRules"
            label-position="right"
            class="demo-form-inline"
            :inline="true"
            size="mini"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="审批意见" prop="verifyIdea">
                <el-input
                    v-model="dataForm.verifyIdea"
                    type="textarea"
                    autosize
                    style="width: 170%"
                    auto-complete="off"
                    placeholder="请输入审批意见"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="附件" prop="attacth">
                <file-upload v-model="dataForm.attacth" :isShowTip="false"/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div
            class="demo-drawer__footer"
            style="text-align: center; margin: 60px 0 20px"
            v-if="buttonShow"
        >
          <!-- <el-button @click.native="cancel">关闭</el-button> -->
          <!-- :loading="editLoading" -->
          <el-button type="success" @click.native="ceasepost(1)"
          >同意
          </el-button
          >
          <!-- :loading="editLoading" -->
          <el-button type="warning" @click.native="ceasepost(2)"
          >不同意
          </el-button
          >
          <!-- <el-button
            :loading="editLoading"
            type="danger"
            @click.native="ceasepost(3)"
            >驳回</el-button
          > -->
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  getFormGroups,
  SubmitInstance,
  GetFlowInstancePage,
  GetFlowInstance,
  GetFlowInstanceCC,
  VerifyInstance,
  GetOpeateRecList,
  ExistInstance,
  GenerateInstance,
  InitFlowNode,
  SetCustomVerifiy,
  GetMakeCard,
  GetChangeApply,
  GetApply,
} from "@/api/design";
import InitiateProcess1 from "./InitiateProcess1";
import InitiateProcess from "./InitiateProcess";
import Pagination from "@/components/Pagination";

export default {
  name: "workSpace",
  components: {InitiateProcess1, InitiateProcess, Pagination},
  data() {
    return {
      activeTab: 0,
      MakeCardList: {},
      ApplyList: {},
      ids: "",
      AltUserList: [],
      processList: [],
      queryParams4: {
        userId: this.$route.params.userId,
        pageNum: 1,
        pageSize: 10,
        flag: "", //1-待我处理、2-关于我的、3-我发起的、4-抄送给我
      },
      queryParams3: {
        userId: this.$route.params.userId,
        pageNum: 1,
        pageSize: 10,
        flag: "", //1-待我处理、2-关于我的、3-我发起的、4-抄送给我
      },
      queryParams2: {
        userId: this.$route.params.userId,
        pageNum: 1,
        pageSize: 10,
        flag: "", //1-待我处理、2-关于我的、3-我发起的、4-抄送给我
      },
      queryParams: {
        userId: this.$route.params.userId,
        pageNum: 1,
        pageSize: 10,
        flag: "", //1-待我处理、2-关于我的、3-我发起的、4-抄送给我
      },
      total: 0,
      total2: 0,
      total3: 0,
      total4: 0,
      instanceId: "",
      activiteId: "",
      editLoading: false,
      dataForm: {
        userId: this.$route.params.userId,
        nickName: this.$route.params.nickName,
      },
      dataFormRules: {
        Status: [
          {required: true, message: "审核结果不能为空", trigger: "change"},
        ],
      },
      activities: [],
      Show: false,
      formData: [],
      shenPiList: {}, // 审批详情
      drawer: false,
      InitFlowNodeList: [],
      activeName: "审批列表",
      buttonShow: true,
      tableData: {},
      tableData2: {},
      tableData3: {},
      tableData4: {},
      loading: false,
      tableDataLoading: false,
      tableData2Loading: false,
      tableData3Loading: false,
      tableData4Loading: false,
      tptId: "",
      openItemDl: false,
      selectForm: {},
      formItem: {},
      actives: [],
      formList: {
        list: [],
        name: "",
        searchResult: [],
      },
      pending: {
        list: [],
      },
    };
  },
  
  mounted() {
    console.log(this.$route.params);
    this.getGroups();
  },
  methods: {
    handelApproval() {
    },
    // 审批
    handleSuccess(row) {
      console.log(row);
      this.activiteId = row.activiteId;
      this.instanceId = row.instanceId;
      this.drawer = true;
      this.buttonShow = true;
      // 获取审批详情
      GetFlowInstance({instanceId: row.instanceId}).then((res) => {
        this.shenPiList = res.data;
        if (res.data.TptGroupId == "TG_MakeCard") {
          // 制证 => 获取制证表单详情
          GetMakeCard({makeId: res.data.BillId}).then((res) => {
            if (res.code == 200) {
              this.MakeCardList = res.data;
            }
          });
        }
        if (res.data.TptGroupId == "TG_TMUpgrade") {
          // 转正申请 => 获取转正申请表单详情
          GetChangeApply({memberId: res.data.BillId}).then((res) => {
            if (res.code == 200) {
              this.ApplyList = res.data;
            }
          });
        }
        this.formData = JSON.parse(this.shenPiList.formData);
        // this.formData = eval("(" + this.shenPiList.formData + ")");
        if (this.shenPiList.formData.length > 4) {
          this.Show = true;
        } else {
          this.Show = false;
        }
      });
      // 获取审批进度
      GetOpeateRecList({instanceId: row.instanceId}).then((res) => {
        if (res.code == 200) {
          this.processList = res.data;
        }
      });
    },
    // 获取审批记录详情
    handleSuccess2(row) {
      this.drawer = true;
      this.buttonShow = false;
      GetFlowInstance({instanceId: row.instanceId}).then((res) => {
        this.shenPiList = res.data;
        if (res.data.TptGroupId == "TG_MakeCard") {
          // 制证 => 获取制证表单详情
          GetMakeCard({makeId: res.data.BillId}).then((res) => {
            if (res.code == 200) {
              this.MakeCardList = res.data;
            }
          });
        }
        if (res.data.TptGroupId == "TG_TMUpgrade") {
          // 转正申请 => 获取转正申请表单详情
          GetApply({memberId: res.data.BillId}).then((res) => {
            if (res.code == 200) {
              this.ApplyList = res.data;
            }
          });
        }
        this.formData = JSON.parse(this.shenPiList.formData);

        if (this.shenPiList.formData.length > 4) {
          this.Show = true;
        } else {
          this.Show = false;
        }
      });
      GetOpeateRecList({instanceId: row.instanceId}).then((res) => {
        this.processList = res.data;
      });
    },
    // 获取审批记录详情(抄送给我)
    handleSuccess3(row) {
      this.drawer = true;
      this.buttonShow = false;
      GetFlowInstanceCC({
        instanceId: row.instanceId,
        userId: this.$route.params.userId,
      }).then((res) => {
        this.shenPiList = res.data;
        if (res.data.TptGroupId == "TG_MakeCard") {
          // 制证 => 获取制证表单详情
          GetMakeCard({makeId: res.data.BillId}).then((res) => {
            if (res.code == 200) {
              this.MakeCardList = res.data;
            }
          });
        }
        if (res.data.TptGroupId == "TG_TMUpgrade") {
          // 转正申请 => 获取转正申请表单详情
          GetApply({memberId: res.data.BillId}).then((res) => {
            if (res.code == 200) {
              this.ApplyList = res.data;
            }
          });
        }
        this.formData = JSON.parse(this.shenPiList.formData);

        if (this.shenPiList.formData.length > 4) {
          this.Show = true;
        } else {
          this.Show = false;
        }
      });
      GetOpeateRecList({instanceId: row.instanceId}).then((res) => {
        this.processList = res.data;
      });
    },
    ceasepost(val) {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.dataForm.instanceId = this.instanceId;
          this.dataForm.activiteId = this.activiteId;
          this.dataForm.verifyFlag = val;
          this.formData.forEach((i) => {
            i.value = this.$store.state.formValue[i.id];
          });
          this.dataForm.formData = JSON.stringify(this.formData);
          console.log(this.dataForm, "dataForm");
          this.editLoading = true;
          VerifyInstance(this.dataForm).then((res) => {
            this.editLoading = false;
            if (res.code === 200) {
              this.$message({message: "操作成功", type: "success"});
              this.getMyFlowInstancePage();
              this.$refs["dataForm"].resetFields();
              this.cancel();
            } else {
              this.$message({message: "操作失败, " + res.msg, type: "error"});
            }
          });
        }
      });
    },
    cancel() {
      this.drawer = false;
      this.shenPiList = {};
      this.Show = false;
      this.dataForm = {
        instanceId: null,
        verifyFlag: null,
        activiteId: null,
        verifyIdea: null,
        attacth: null,
        userId: this.$route.params.userId,
        nickName: this.$route.params.nickName,
      };
    },
    getActiveTab(index) {
      this.$nextTick(() => {
        const element = document.getElementById("tab-" + this.activeTab);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });
    },
    goList(val) {
      // 跳转到审批列表
      var path =
          "/approvalList/" +
          this.$route.params.userId +
          "/" +
          this.$route.params.platformId +
          "/" +
          this.$route.params.companyId +
          "/" +
          this.$route.params.nickName +
          "/" +
          val;
      if (window.__wxjs_environment === "miniprogram") {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: "../public/shenpi?path=" + path,
        });
      } else {
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        this.$router.push(path);
      }
    },
    handleClick(tab) {
      console.log(tab);
      if (tab.name == "审批列表") {
        this.tableDataLoading = true;
        this.getGroups();
      }
      if (tab.name == "待我处理") {
        this.queryParams.flag = 1;
        this.tableDataLoading = true;
        this.getMyFlowInstancePage();
      }
      if (tab.name == "我处理的") {
        this.tableData2Loading = true;
        this.queryParams2.flag = 2;
        this.getMyFlowInstancePage2();
      }
      if (tab.name == "我发起的") {
        this.tableData3Loading = true;
        this.queryParams3.flag = 3;
        this.getMyFlowInstancePage3();
      }
      if (tab.name == "抄送给我") {
        this.tableData4Loading = true;
        this.queryParams4.flag = 4;
        this.getMyFlowInstancePage4();
      }
    },
    // 获取待我处理 列表
    async getMyFlowInstancePage() {
      const res = await GetFlowInstancePage(this.queryParams);
      this.tableData = res.data;
      this.total = res.data.total;
      this.tableDataLoading = false;
    },
    // 获取待我处理 列表
    async getMyFlowInstancePage2() {
      const res = await GetFlowInstancePage(this.queryParams2);
      this.tableData2 = res.data;
      this.total2 = res.data.total;
      this.tableData2Loading = false;
    },
    async getMyFlowInstancePage3() {
      const res = await GetFlowInstancePage(this.queryParams3);
      this.tableData3 = res.data;
      this.total3 = res.data.total;
      this.tableData3Loading = false;
    },
    async getMyFlowInstancePage4() {
      const res = await GetFlowInstancePage(this.queryParams4);
      this.tableData4 = res.data;
      this.total4 = res.data.total;
      this.tableData4Loading = false;
    },
    getSearch() {
      clearTimeout(this.timer);
      this.loading = true;
      this.timer = setTimeout(() => {
        this.getGroups();
      }, 1000);
    },
    getGroups() {
      this.loading = true;
      getFormGroups({
        name: this.formList.name,
        companyId: this.$route.params.companyId,
        platformId: this.$route.params.platformId,
      }).then((rsp) => {
        this.formList.list = rsp.data;
        this.formList.list.forEach((group) => {
          this.actives.push(group.name);
          group.tptList.forEach((item) => {
            item.Icon = JSON.parse(item.logo);
          });
        });
        this.groups = rsp.data;
        this.loading = false;
      });
      // .catch((err) => this.$message.error("获取分组异常"));
    },
    Close() {
      this.openItemDl = false;
      this.ids = "";
    },
    enterItem(item) {
      this.selectForm = item;
      this.tptId = item.tptId;
      this.initFlowNode(item.tptId, item.name);
    },
    // 2.初始化并加载审批节点(进度流程)
    initFlowNode(val, name) {
      console.log(val);
      console.log(name, '请假吗');
      this.instanceId = val;
      InitFlowNode({tptId: val}).then((res) => {
        if (res.code == 200) {
          console.log(res.data, "进度流程");
          this.InitFlowNodeList = res.data;
          this.InitFlowNodeList.forEach((i) => {
            if (i.selfSelect == 1) {
              // 自选 =>设置自选审批人
              this.AltUserList = i.AltUserList;
              // SetCustomVerifiy({ instanceId: val }).then((res) => {
              //   if (res.code == 200) {
              //     console.log(res.data, "自选审批人");
              //   }
              // });
            }
          });
          // 跳转到发起审批 页面
          var path =
              "/approval/" +
              this.tptId +
              "/" +
              this.$route.params.userId +
              "/" +
              this.$route.params.platformId +
              "/" +
              this.$route.params.companyId +
              "/" +
              this.$route.params.nickName +
              "/" +
              this.$route.params.deptId +
              "/" +
              name;
          this.$router.push(path);
          //   this.openItemDl = true;
        }
      });
    },
    handleCommand(val) {
      console.log(val);
      this.AltUserList.forEach((i) => {
        if (i.id == val) {
          console.log(i.name);
          this.InitFlowNodeList.forEach((j) => {
            if (j.nodeType == "APPROVAL" && j.selfSelect == 1) {
              console.log(j);
              j.MakerIds = i.id;
              j.makers = i.name;
            }
          });
        }
      });
    },
    handleCommand1() {
      var arr = [];
      this.InitFlowNodeList.forEach((j) => {
        if (j.nodeType == "APPROVAL" && j.selfSelect == 1) {
          console.log();
          arr = j.AltUserList;
        }
      });
      console.log(arr, "arr");
      console.log(this.ids, "ids");
      var Names = [];
      var Ids = [];
      this.ids.forEach((i) => {
        arr.forEach((j) => {
          if (j.id == i) {
            console.log(j.name);
            Names.push(j.name);
            Ids.push(j.id);
          }
        });
      });
      console.log(Names);
      console.log(Ids);
      this.InitFlowNodeList.forEach((j) => {
        if (j.nodeType == "APPROVAL" && j.selfSelect == 1) {
          j.MakerIds = Ids + "";
          j.makers = Names + "";
        }
      });
      console.log(this.InitFlowNodeList, "this.InitFlowNodeList");
    },
    submitForm() {
      this.$refs.processForm.validate((valid) => {
        if (valid) {
          console.log(this.InitFlowNodeList, "this.InitFlowNodeList");
          if (this.InitFlowNodeList.length > 0) {
            console.log(this.$store.state.formValue);
            var formItems = this.$store.state.design.formItems;
            console.log(formItems, "formItems");
            for (let i = 0; i < formItems.length; i++) {
              const e = formItems[i];
              e.value = this.$store.state.formValue[e.id];
            }
            console.log(this.$store.state.design.formItems);

            // return;
            for (var i = 0; i < this.InitFlowNodeList.length; i++) {
              if (
                  this.InitFlowNodeList[i].nodeType == "APPROVAL" &&
                  this.InitFlowNodeList[i].MakerIds == ""
              ) {
                this.$message({
                  message: "请选择审批人",
                  type: "warning",
                });
                return false;
              }
            }
            SubmitInstance({
              userId: this.$route.params.userId,
              nickName: this.$route.params.nickName,
              companyId: this.$route.params.companyId,
              platformId: this.$route.params.platformId,
              instanceId: this.instanceId,
              flag: 2,
              flowNodes: JSON.stringify(this.InitFlowNodeList),
              tptId: this.tptId,
              formData: JSON.stringify(this.$store.state.design.formItems),
            }).then((res) => {
              if (res.code === 200) {
                this.$message({message: "发起成功", type: "success"});
                this.openItemDl = false;
                this.$refs["processForm"].resetFields();
                this.getGroups();
              } else {
                this.$message({
                  message: "操作失败, " + res.msg,
                  type: "error",
                });
              }
            });
          } else {
            this.$message.warning("请先完善审批流程😥");
          }
        } else {
          this.$message.warning("请完善表单😥");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.workspace {
  position: relative;

  .back {
    position: absolute;
    left: 20px;
    top: 13px;
  }

  .no-data {
    text-align: center;
    padding: 50px 0;
    color: #656565;
    margin: 0 auto;
    font-family: PingFang SC;
  }

  /deep/ .el-collapse {
    padding: 0 15px;
    background: #ffffff;
    border: none;

    .el-collapse-item__header {
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 15px;
      color: #1e1e1e;
      border: none;
    }

    .el-collapse-item__wrap {
      //   padding: 0px 10px;
      border: none;

      .el-collapse-item__content {
        padding-bottom: 0;
      }
    }

    .el-tabs--border-card .el-tabs__content {
      padding: 40px 15px;
    }
  }

  .form-item {
    flex-basis: 25%;
    margin-bottom: 12px;

    &:hover {
      // border: 1px solid #448ed7;

      span {
        display: inline-block !important;
      }
    }

    i {
      padding: 8px;
      border-radius: 8px;
      float: left;
      font-size: 28px;
      color: #ffffff;
      background: #38adff;
      line-height: 28px;
    }

    div {
      span {
        display: none;
        float: right;
        color: #38adff;
        font-size: 12px;
      }
    }
  }
}

.icon {
  display: block;
  width: 33px;
  height: 33px;
  vertical-align: middle;
  margin-right: 10px;
  border-radius: 10px;
}

.spDrawer /deep/ .el-input {
  width: 100% !important;
}

.shenpi /deep/ .el-drawer__body {
  background-color: #eee;
}

.shenpi /deep/ .el-drawer__body {
  padding: 0;
}

.shenpi /deep/ .el-drawer__header {
  margin-bottom: 32px;
}

.shenpi .title {
  padding: 0 25px;
  background: #ffffff;
}

.shenpi .form {
  margin-top: 15px;
  background: #fff;
  padding: 10px 25px;
}

.el-timeline-item {
  padding-bottom: 50px;
}

/deep/ .el-timeline-item__tail {
  border-left: 2px solid #397affbf;
}

/deep/ .el-timeline-item__node {
  background-color: #397aff;
}

.el-select /deep/ .el-input__inner {
  border: none !important;
}
</style>

<style scoped>
.tab {
  display: flex;
  justify-content: space-around;
  background-color: #ededee;
  box-sizing: border-box;
  padding: 15px 0;
}

.tab img {
  display: block;
  width: 20px;
  height: 22px;
}

.tab .item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.item div {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #1e1e1e;
  margin-top: 12px;
}

/deep/ .van-tab {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #999999;
  flex: none;
  padding: 0 15px;
}

/deep/ .van-tab--active {
  color: #1e1e1e;
  font-weight: bold;
}

/deep/ .van-tabs__line {
  width: 18px;
  height: 3px;
  background: #1e1e1e;
  border-radius: 2px;
}

.line {
  text-align: center;
  margin-top: 6px;
}

.tptName {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 11px;
  color: #666666;
  text-align: center;
  width: 66px;
  margin-top: 6px;
}

/deep/ ::-webkit-scrollbar {
  display: none;
}
</style>
